/* eslint-disable no-underscore-dangle */
declare global {
  interface Window {
    _satellite?: {
      track: (event: string, data: Record<string, unknown>) => void;
    };
  }
}

export function trackPageView(pageName: string) {
  window._satellite?.track('page-view', { name: pageName });
}
